import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';

// The client name title. A Loom lead is read-only, so the name cannot be clicked to edit it.
const ClientName = (props) => {
  const {clientData} = props;

  const clientName = clientData.clientName;
  const primaryRelationship = Object.values(clientData.relationships ?? {}).find((rel) => rel.name === clientName);
  const connectionType = primaryRelationship?.connectionType;

  return (
    <Box
      sx={{
        cursor: 'default',
      }}
    >
      <Typography sx={{fontSize: '28px', fontWeight: 400}}>
        {clientName}
        {
          connectionType &&
          ` (${connectionType})`
        }
      </Typography>
    </Box>
  );
};

ClientName.propTypes = {
  clientData: PropTypes.object.isRequired,
};

export default React.memo(ClientName);
